import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfUse from './TermsOfUse';

const DisclosureLink = {
    privacyPolicy: 'PrivacyPolicy',
    termsOfUse: 'TermsOfUse',
}

export default function TermsAndConditions() {
    const [disclosureDialogOpen, setDisclosureDialogOpen] = useState(false);
    const [component, setComponent] = useState(null);
    const handleDisclosureLink = (link) => {
        if (link === DisclosureLink.privacyPolicy) {
            setComponent(<PrivacyPolicy></PrivacyPolicy>);
        } else if (link === DisclosureLink.termsOfUse) {
            setComponent(<TermsOfUse></TermsOfUse>)
        }
        setDisclosureDialogOpen(true);
    }
    return (
        <div>
            <h4>Terms and Conditions</h4>
            <p>Your use of this Platform, including the submission of any insurance application(s), is covered by Covr’s Terms of Use (posted <a className='term-condition-link' onClick={() => handleDisclosureLink(DisclosureLink.termsOfUse)}><span className='term-link-color'>here</span></a>) and our Privacy Policy (found <a className='term-condition-link' onClick={() => handleDisclosureLink(DisclosureLink.privacyPolicy)}><span className='term-link-color'>here</span></a>). Please review the Terms of Use and Privacy Policy before proceeding.  Capitalized words and phrases used herein are defined terms and the definitions are found either in these Terms of Use or our Privacy Policy.</p>

            <h5>Insurance Products</h5>
        <p>Eligible individuals may apply for insurance products through the Platform. Insurance products are only available to people in those jurisdictions in which they may be legally sold. By applying for insurance products through the Platform, you are agreeing to (i) designate us (or our individual designee) as your agent of record, (ii) authorize us to communicate such designation to any insurance carrier, your prior insurance producer, and any other person or entity we determine should be informed of such designation, and (iii) permit us to receive compensation that insurance carrier(s) in connection with your purchase of insurance products. With respect to any insurance product, if any term or condition of this Platform differs from the terms and conditions of the policy, the policy's provisions will control.</p>
            <p>Product information and descriptions contained on this Platform are not intended to be complete descriptions of all applicable terms, exclusions and conditions, but are provided solely for general informational purposes. If you purchase a policy through this Platform, you should refer to the actual policy for complete details of coverage. Approval of your application is not guaranteed and is subject to acceptance by the applicable carrier based upon its underwriting guidelines.</p>

            <h5>No Professional Advice</h5>
            <p>We do not provide any form of professional advice of the type that may require additional professional licensing, such as legal, medical, accounting, or tax advice. The Platform does not contain any legal, regulatory, accounting, or tax advice, and you must rely solely upon your own advisors with respect to such advice.</p>

            <DisclosureDialog
                open={disclosureDialogOpen}
                onDisclosureDialogClosed={() => {
                    setDisclosureDialogOpen(false);
                }}
                component={component}
            />
        </div>
    )
}

function DisclosureDialog(props) {
    return (
        <div>
            <Dialog maxWidth="md" open={props.open} onClose={props.onDisclosureDialogClosed} scroll="body">
                <DialogContent className="product-info-dialog-content">
                    <IconButton className="product-info-close-button" aria-label="close" onClick={props.onDisclosureDialogClosed}>
                        <CloseIcon />
                    </IconButton>
                    {props.component}
                </DialogContent>
            </Dialog>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/Disclosure/TermsAndConditions.js